function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDarkMode = function SvgDarkMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.387
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 53357"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 2",
    d: "M8.007 3.158V1.252H4.252v1.906a7.524 7.524 0 0 1 3.754 0m1.253 1.853A6.26 6.26 0 0 0 3 5.009V0h6.259z",
    transform: "translate(3.872)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 2",
    d: "M6.259 12.517A6.26 6.26 0 0 1 .835 3.133l.926.926a4.947 4.947 0 0 0-.51 2.2 5.013 5.013 0 0 0 5.007 5.007 4.947 4.947 0 0 0 2.2-.509l.926.926a6.257 6.257 0 0 1-3.125.834zm4.154-1.577-.888-.888a5 5 0 1 0-7.059-7.059L1.577 2.1a6.258 6.258 0 1 1 8.836 8.835z",
    transform: "translate(3.743 3.129)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29315",
    transform: "rotate(-45 5.99 -2.57)",
    style: {
      fill: "currentColor"
    },
    d: "M0 0h1.252v16.689H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29317",
    transform: "rotate(-90 4.784 4.784)",
    style: {
      fill: "currentColor"
    },
    d: "M0 0h1.252v2.698H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29318",
    transform: "rotate(-90 13.435 -3.867)",
    style: {
      fill: "currentColor"
    },
    d: "M0 0h1.252v2.698H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29319",
    transform: "rotate(180 5.312 9.693)",
    style: {
      fill: "currentColor"
    },
    d: "M0 0h1.252v2.698H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29320",
    transform: "rotate(-135 4.986 7.707)",
    style: {
      fill: "currentColor"
    },
    d: "M0 0h1.252v2.698H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 29321",
    transform: "rotate(-45 25.176 -10.348)",
    style: {
      fill: "currentColor"
    },
    d: "M0 0h1.252v2.698H0z"
  })));
};

export default SvgDarkMode;